import { OurBlogsComponent } from './our-blogs/our-blogs.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { Routes, RouterModule } from '@angular/router';

import { InheritxSolutionsComponent } from './inheritx-solutions/inheritx-solutions.component';
import { OurServicesComponent } from './our-services/our-services.component';
import { OurPortfolioComponent } from './our-portfolio/our-portfolio.component';
import { OurPartnersComponent } from './our-partners/our-partners.component';
import { OurTestimonialsComponent } from './our-testimonials/our-testimonials.component';
import { OurTeamComponent } from './our-team/our-team.component';
import { OurClientsComponent } from './our-clients/our-clients.component';
import { TalkToOurExpertsComponent } from './talk-to-our-experts/talk-to-our-experts.component';
import { SharedModule } from '../../shared/shared.module';
import { SliderComponent } from './slider/slider.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
];

@NgModule({
  declarations: [
    HomeComponent,
    InheritxSolutionsComponent,
    OurServicesComponent,
    OurPortfolioComponent,
    OurPartnersComponent,
    OurTestimonialsComponent,
    OurTeamComponent,
    OurClientsComponent,
    TalkToOurExpertsComponent,
    OurBlogsComponent,
    SliderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  entryComponents: [HomeComponent],
})
export class HomeModule { }
